import type { TEntityId } from '~/types/models'
import { httpPost, httpPatchMerge, httpDelete } from '~/services/http'
import type { TEntityNote } from '~/types/note/models'

export function makeNoteService<T extends TEntityNote>(
  apiEntityPath: string,
  entityName: string
) {
  async function createNote(entity: T) {
    const callingMn = `${createNote.name} (${entityName}) |`
    const apiPath = apiEntityPath
    return httpPost<T>({
      callingMn,
      apiPath,
      entity,
    })
  }
  async function updateNote(entityData: Partial<T>, id: TEntityId) {
    const callingMn = `${updateNote.name} (${entityName})`
    const apiPath = `${apiEntityPath}/${id}`
    return httpPatchMerge<Partial<T>>({
      callingMn,
      apiPath,
      entityData,
    })
  }
  async function deleteNote(entityData: T) {
    const callingMn = `${deleteNote.name} (${entityName})`
    const apiPath = apiEntityPath
    return httpDelete<T>({
      callingMn,
      apiPath,
      entityData,
    })
  }
  return { createNote, updateNote, deleteNote }
}
